/**
 * Estado demo: frequência “realizada” por slot do horário (chave estável).
 * Usado nos atalhos do calendário e após salvar em Frequência.
 */

const STORAGE_KEY = "waybee-demo-schedule-slot-status";

function readAll() {
  if (typeof sessionStorage === "undefined") return {};
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
}

function writeAll(data) {
  if (typeof sessionStorage === "undefined") return;
  sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

export function getDemoScheduleSlotStatus(slotKey) {
  if (!slotKey) {
    return { frequencyDone: false };
  }
  const row = readAll()[slotKey];
  return { frequencyDone: Boolean(row && row.frequencyDone) };
}

export function markDemoScheduleSlotFrequencyDone(slotKey) {
  if (!slotKey) return;
  const all = readAll();
  all[slotKey] = { ...all[slotKey], frequencyDone: true };
  writeAll(all);
}

export const DEMO_SCHEDULE_SLOT_STORAGE_KEY = STORAGE_KEY;
